import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Person } from '@factorialco/f0-react/icons/app'
import { Moment } from 'moment'

import { observer } from 'mobx-react'

import { getResources } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/getResources'
import { useCalculateSummaryUnassignedShifts } from 'modules/shift_management/hooks/useCalculateSummaryUnassignedShifts'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import { useUnassignedShifts } from 'modules/shift_management/hooks/useUnassignedShifts'
import { ShiftsRow } from 'modules/shift_management/lib/types'
import UnassignedShifts from 'modules/shift_management/store/internal/collections/UnassignedShifts'
import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'

interface CellProps {
  date: Moment
}

const CoverageShiftsSummary = ({ date }: CellProps) => {
  const [unassignedShifts] = useUnassignedShifts()
  const [{ shiftsRows }] = useShiftsRows()
  const [{ view }] = useSchedule()
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')

  const shiftsByDate = shiftsRows.flatMap((row: ShiftsRow) => {
    const { shifts } = getResources(row, date, view)
    return shifts
  })

  const unassignedShiftsCollection = new UnassignedShifts(unassignedShifts)
  const unassignedShiftsByDate = unassignedShiftsCollection.filterByDate(date)

  const { totalCounters, totalTime } = useCalculateSummaryUnassignedShifts({
    unassignedShifts: unassignedShiftsByDate,
  })

  const assignedShifts = unassignedShiftsByDate.flatMap((unassignedShift: UnassignedShift) => {
    return unassignedShift.assignedShifts(shiftsByDate)
  })
  const totalAssignedShifts = assignedShifts.length

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s8"
      width="full"
      height={newEntryFlowEnabled ? 'full' : 's16'}
      padding={newEntryFlowEnabled ? undefined : 's4'}
      border={{
        right: newEntryFlowEnabled ? undefined : { width: 's1', style: 'solid', color: 'grey300' },
      }}
      background={newEntryFlowEnabled ? undefined : 'grey100'}
    >
      <Box
        flexDirection="row"
        alignItems="center"
        width="full"
        justifyContent={newEntryFlowEnabled ? 'center' : 'flexStart'}
        gap="s2"
      >
        <F0Icon icon={Person} size="sm" color={newEntryFlowEnabled ? 'secondary' : undefined} />
        <Text
          size={newEntryFlowEnabled ? '100' : '50'}
          weight={newEntryFlowEnabled ? 'normal' : 'bold'}
          className={newEntryFlowEnabled ? 'text-f1-foreground' : undefined}
        >
          {totalAssignedShifts} / {totalCounters}
        </Text>
      </Box>
      {newEntryFlowEnabled ? null : (
        <Box flexDirection="row" alignItems="center" width="full" justifyContent="flexEnd">
          <Text size="50" weight="bold">
            {totalTime}
          </Text>
        </Box>
      )}
    </Box>
  )
}

export default observer(CoverageShiftsSummary)
